const themeCoordsColorsWithHighOpacity = [
    "rgba(207, 233, 254, 1)",
    "rgba(242, 222, 254, 1)",
    "rgba(242, 76, 61, 0.5)",
    "rgba(3, 201, 136, 0.5)",
    "rgba(127, 140, 237, 1)",
    "rgba(81, 107, 120, 0.85)",
    "rgba(50, 30, 30, 0.5)",
    "rgba(14, 131, 136, 0.5)",
    "rgba(109, 103, 228, 0.5)",
    "rgba(193, 71, 233, 0.5)",
  ];

const themeCoordColors = [
    "rgba(207, 233, 254, 0.8)",
    "rgba(242, 222, 254, 0.8)",
    "rgba(242, 76, 61, 0.3)",
    "rgba(3, 201, 136, 0.3)",
    "rgba(127, 140, 237, 0.8)",
    "rgba(81, 107, 120, 0.65)",
    "rgba(50, 30, 30, 0.3)",
    "rgba(14, 131, 136, 0.3)",
    "rgba(109, 103, 228, 0.3)",
    "rgba(193, 71, 233, 0.3)",
];

export {themeCoordsColorsWithHighOpacity, themeCoordColors};